import { _noop } from '@client/new/helpers/general';
import { SessionSubscriber } from '../sessionTracker';

export const loggerSessionSubscriber: SessionSubscriber = {
  name: 'SessionSubscriber.Console',
  onInit: (session) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).session = session;
    console.log(
      'Session initialized:',
      session.sessionId,
      session.url,
      session.createdAt,
    );
  },
  onEvent: (event) => {
    console.log('Event received:', event.type, event.value);
  },
  sync: _noop,
};
